import { useRef, useEffect, useState } from 'react'
import { Helmet } from "react-helmet";
import db from "../firebase-config"
import { Box, Grid, Container, Tab, Tabs, Toolbar, Typography, useTheme } from "@mui/material";
import { tokens } from "../theme";
import HeaderDetail from '../components/header/HeaderDetail';
import { styled } from '@mui/material/styles';
import Paper from '@mui/material/Paper';
import Target from "../assets/img/svg/target.svg"
import LightModeOutlinedIcon from "@mui/icons-material/LightModeOutlined";
import DarkModeOutlinedIcon from "@mui/icons-material/DarkModeOutlined";
import GrigToDetail from "../components/grid/GridToDetail";
import Fighting from "../assets/img/first1.gif";
import Running from "../assets/img/running.gif"
import Run from '../assets/img/running_png.png';
import Fist from '../assets/img/protest_png.png';
import { useParams } from 'react-router-dom';


const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: '#bcd6d0',
  padding: theme.spacing(0.8),
  textAlign: 'center',
  //border: '0.8px dashed #2e9281',
  //borderRadius: 10,
  width: '101.5%',
  position: "relative",
  left: '-1.5vw'

}));

const ItemTarget = styled(Paper)(({ theme }) => ({
  backgroundColor: '#000000',
  padding: theme.spacing(1),
  textAlign: 'center',
  //border: '0.8px dashed #2e9281',
  borderRadius: 0,
  width: '101.5%',
  position: "relative",
  left: '-1.5vw'

}));


const PerformanceLine8Page1 = () => {
  const { bu, plant, factory, line } = useParams();
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const [performanceP1, setPerformanceP1] = useState([]);
  const [loading, setLoading] = useState(false);
  const [non_production_hour, setNon_production_hour] = useState();
  const [non_production_minute, setNon_production_minute] = useState();
  const [production_hour, setProduction_hour] = useState();
  const [production_minute, setProduction_minute] = useState();



  const performance = () => {
    try {

      const buName = bu;
      const plantName = plant;
      const factoryName = factory;
      const lineName = line;
      const lineMapping = {
        "แปรรูปไก่_4071_FPP1_Line1": 'LINE1',
        "แปรรูปไก่_4071_FPP1_Line2": 'LINE2',
        "แปรรูปไก่_4071_FPP1_Line3": 'LINE3',
        "แปรรูปไก่_4071_FPP1_Line4": 'LINE4',
        "แปรรูปไก่_4071_FPP1_Line5": 'LINE5',
        "แปรรูปไก่_4071_FPP1_Line6": 'LINE6',

        "แปรรูปไก่_4117_FPP2_Line7": 'LINE7',
        "แปรรูปไก่_4117_FPP2_Line8": 'LINE8',
        "แปรรูปไก่_4117_FPP2_Line9": 'LINE9',
        "แปรรูปไก่_4117_FPP2_Line10": 'LINE10',
      };

      const key = `${buName}_${plantName}_${factoryName}_${lineName}`;

      return lineMapping[key];
    } catch (error) {
      console.error("Error in line_performance:", error);
      return null;
    }
  };


  useEffect(() => {
    const docId = `${plant}00000000000000${performance()}ViaTumblerPerformance`;
    const docRef = db.collection('prod_mes_ignition_performance_page12_v2').doc(docId);

    const unsubscribe = docRef.onSnapshot((docSnapshot) => {
      if (docSnapshot.exists) {
        setPerformanceP1([{ ...docSnapshot.data(), id: docSnapshot.id }][0]);
        setLoading(true)
      } else {
        console.log('No such document!');
        setPerformanceP1([]);
      }
    });
    return () => unsubscribe();
  }, []);


  // useEffect(() => {
  //   if (loading === true) {
  //     const isValidTimeFormat = (time) =>
  //       typeof time === "string" &&
  //       /^\s*(-?\d+\s?day,\s*)?([01]?\d|2[0-3]):([0-5]\d):([0-5]\d)(\.\d+)?\s*$/.test(time);

  //     const parseTime = (time) => {
  //       const timeBefore = time === undefined || time === 'NA' ? ["-1 day", "00:00:00"] : time.split(",");
  //       return Array.isArray(timeBefore) && timeBefore.length >= 1
  //         ? (timeBefore.length === 1 ? timeBefore[0]?.split(":") : timeBefore[1]?.split(":")) || ["00", "00"]
  //         : ["00", "00"];
  //     };

  //     // Check NON_PRODUCTION_TIME
  //     if (isValidTimeFormat(performanceP1?.NON_PRODUCTION_TIME)) {
  //       const nonProductionTime = parseTime(performanceP1?.NON_PRODUCTION_TIME);
  //       setNon_production_hour(Number(nonProductionTime[0]));
  //       setNon_production_minute(Number(nonProductionTime[1]));

  //     } else {
  //       setNon_production_hour(0);
  //       setNon_production_minute(0);
  //     }

  //     // Check PRODUCTION_TIME
  //     if (isValidTimeFormat(performanceP1?.PRODUCTION_TIME)) {
  //       const productionTime = parseTime(performanceP1?.PRODUCTION_TIME);
  //       setProduction_hour(Number(productionTime[0]));
  //       setProduction_minute(Number(productionTime[1]));
  //     } else {
  //       setProduction_hour(0);
  //       setProduction_minute(0);
  //     }
  //   }
  // }, [loading]);

  useEffect(() => {
    if (!performanceP1) return;

    const isValidTimeFormat = (time) =>
      typeof time === "string" &&
      /^\s*(-?\d+\s?day,\s*)?([01]?\d|2[0-3]):([0-5]\d):([0-5]\d)(\.\d+)?\s*$/.test(time);

    const parseTime = (time) => {
      const timeBefore =
        time === undefined || time === "NA"
          ? ["-1 day", "00:00:00"]
          : time.split(",");

      return Array.isArray(timeBefore) && timeBefore.length >= 1
        ? (timeBefore.length === 1
          ? timeBefore[0]?.split(":")
          : timeBefore[1]?.split(":")) || ["00", "00"]
        : ["00", "00"];
    };

    if (performanceP1.NON_PRODUCTION_TIME && isValidTimeFormat(performanceP1.NON_PRODUCTION_TIME)) {
      const nonProductionTime = parseTime(performanceP1.NON_PRODUCTION_TIME);

      setNon_production_hour(Number(nonProductionTime[0]));
      setNon_production_minute(Number(nonProductionTime[1]));
    }

    if (performanceP1.PRODUCTION_TIME && isValidTimeFormat(performanceP1.PRODUCTION_TIME)) {
      const productionTime = parseTime(performanceP1.PRODUCTION_TIME);

      setProduction_hour(Number(productionTime[0]));
      setProduction_minute(Number(productionTime[1]));
    }

  }, [performanceP1]);

  const getChartColor = () => {
    let color;
    try {
      if ((performanceP1?.ACTUAL_WEIGHT == undefined || performanceP1?.ACTUAL_WEIGHT == 'NA' ? 0 : performanceP1?.ACTUAL_WEIGHT) >= (((((production_hour == undefined ? 0 : production_hour) + ((production_minute == undefined ? 0 : production_minute) / 60)) + ((non_production_hour == undefined ? 0 : non_production_hour) + ((non_production_minute == undefined ? 0 : non_production_minute) / 60))) * (performanceP1?.STD_FEED_RATE == undefined || performanceP1?.STD_FEED_RATE == 'NA' || performanceP1?.STD_FEED_RATE == 'ไม่มีข้อมูล Std. Cap ในระบบ' ? 0 : performanceP1?.STD_FEED_RATE)) * 1)) {
        color = "#2e9281"
      } else if ((performanceP1?.ACTUAL_WEIGHT == undefined || performanceP1?.ACTUAL_WEIGHT == 'NA' ? 0 : performanceP1?.ACTUAL_WEIGHT) >= (((((production_hour == undefined ? 0 : production_hour) + ((production_minute == undefined ? 0 : production_minute) / 60)) + ((non_production_hour == undefined ? 0 : non_production_hour) + ((non_production_minute == undefined ? 0 : non_production_minute) / 60))) * (performanceP1?.STD_FEED_RATE == undefined || performanceP1?.STD_FEED_RATE == 'NA' || performanceP1?.STD_FEED_RATE == 'ไม่มีข้อมูล Std. Cap ในระบบ' ? 0 : performanceP1?.STD_FEED_RATE)) * 0.8)) {
        color = "#b58514"
      } else if ((performanceP1?.ACTUAL_WEIGHT == undefined || performanceP1?.ACTUAL_WEIGHT == 'NA' ? 0 : performanceP1?.ACTUAL_WEIGHT) < (((((production_hour == undefined ? 0 : production_hour) + ((production_minute == undefined ? 0 : production_minute) / 60)) + ((non_production_hour == undefined ? 0 : non_production_hour) + ((non_production_minute == undefined ? 0 : non_production_minute) / 60))) * (performanceP1?.STD_FEED_RATE == undefined || performanceP1?.STD_FEED_RATE == 'NA' || performanceP1?.STD_FEED_RATE == 'ไม่มีข้อมูล Std. Cap ในระบบ' ? 0 : performanceP1?.STD_FEED_RATE)) * 0.8)) {
        color = "#7d2e1e"
      }
      return color;
    }
    catch {
      console.log()
    }
  }

  const getFeedrateColor = () => {
    let color;
    try {
      if ((performanceP1?.ACTUAL_FEED_RATE == undefined || performanceP1?.ACTUAL_FEED_RATE == 'NA' ? 0 : performanceP1?.ACTUAL_FEED_RATE) >= ((performanceP1?.STD_FEED_RATE == undefined || performanceP1?.STD_FEED_RATE == 'NA' || performanceP1?.STD_FEED_RATE == 'ไม่มีข้อมูล Std. Cap ในระบบ' ? 0 : performanceP1?.STD_FEED_RATE) * 1)) {
        color = "#2e9281"
      } else if ((performanceP1?.ACTUAL_FEED_RATE == undefined || performanceP1?.ACTUAL_FEED_RATE == 'NA' ? 0 : performanceP1?.ACTUAL_FEED_RATE) >= ((performanceP1?.STD_FEED_RATE == undefined || performanceP1?.STD_FEED_RATE == 'NA' || performanceP1?.STD_FEED_RATE == 'ไม่มีข้อมูล Std. Cap ในระบบ' ? 0 : performanceP1?.STD_FEED_RATE) * 0.8)) {
        color = "#b58514"
      } else if ((performanceP1?.ACTUAL_FEED_RATE == undefined || performanceP1?.ACTUAL_FEED_RATE == 'NA' ? 0 : performanceP1?.ACTUAL_FEED_RATE) < ((performanceP1?.STD_FEED_RATE == undefined || performanceP1?.STD_FEED_RATE == 'NA' || performanceP1?.STD_FEED_RATE == 'ไม่มีข้อมูล Std. Cap ในระบบ' ? 0 : performanceP1?.STD_FEED_RATE) * 0.8)) {
        color = "#7d2e1e"
      }
      return color;
    }
    catch {
      console.log()
    }
  }


  return (
    <>
      <Helmet>
        <title>Performance Page1 | MES</title>
      </Helmet>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={12}>
          <HeaderDetail
            line={line}
            sku={performanceP1?.IS_SKU_MATCHED?.toLowerCase() === 'yes'
              ? (performanceP1?.SKU || '-')
              : 'ไม่ตรงแผนผลิต'
            }
            icon={performanceP1?.SHIFT === "N" ? (<DarkModeOutlinedIcon style={{ height: '55px' }} />) : (<LightModeOutlinedIcon style={{ height: '55px' }} />)}
          />
        </Grid>
      </Grid>

      <Grid item xs={12} sm={12}>
        <Item>
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }} textAlign="center" >
            <Typography style={{ color: '#b58514', fontSize: 20, lineHeight: "17px", fontWeight: 'bold' }} >
              <img src={Target} height="120px" />
            </Typography>
            <Typography style={{ color: colors.neutral['green'], fontSize: 100, fontWeight: 'bold', lineHeight: "17px", paddingTop: 5 }} >
              &nbsp;เป้าหมาย&nbsp;
            </Typography>
            <Typography style={{ color: colors.neutral['green'], fontSize: 120, lineHeight: "17px", fontWeight: 'bold' }} >
              &nbsp;{performanceP1?.TARGET_WEIGHT_KG === undefined ? 0 : (performanceP1?.TARGET_WEIGHT_KG).toLocaleString()}&nbsp;
            </Typography>
            <Typography style={{ color: colors.neutral['green'], fontSize: 50, lineHeight: "17px", fontWeight: 'bold', paddingTop: 20 }} >
              กก.
            </Typography>
          </Box>
        </Item>

      </Grid>

      <Grid item xs={12} sm={12}>
        <ItemTarget>
          <Grid container rowSpacing={0.8} columnSpacing={{ xs: 0, sm: 0, md: 0 }} >
            <GrigToDetail
              color={performanceP1?.ACTUAL_WEIGHT == undefined ? colors.neutral['green'] : (performanceP1?.ACTUAL_WEIGHT === 'NA' ? colors.neutral['green'] : getChartColor())}
              image={performanceP1?.IS_RUNNING != undefined ? (performanceP1?.IS_RUNNING == 'YES' ? <img src={Fighting} height="100vh" /> : <img src={Fist} height="100vh" />) : <img src={Fist} height="100vh" />}
              section={'ทำได้'}
              persent={performanceP1?.PERCENT_ACTUAL_WEIGHT === undefined ? 0 : performanceP1?.PERCENT_ACTUAL_WEIGHT}
              color_persent={performanceP1?.ACTUAL_WEIGHT == undefined ? colors.neutral['green'] : (performanceP1?.ACTUAL_WEIGHT === 'NA' ? colors.neutral['green'] : getChartColor())}
              value={performanceP1?.ACTUAL_WEIGHT === undefined ? 0 : Math.round(performanceP1?.ACTUAL_WEIGHT).toLocaleString()}
            />

            <GrigToDetail
              color={'#4a4a49'}
              image={performanceP1?.IS_RUNNING != undefined ? (performanceP1?.IS_RUNNING == 'YES' ? <img src={Running} height="100vh" /> : <img src={Run} height="100vh" />) : <img src={Run} height="100vh" />}
              //width={no_data === 1 ? (performanceP1.ACTUAL_WEIGHT_PERCENT === 'NA' ? '20vh' : (100 - performanceP1.ACTUAL_WEIGHT_PERCENT < 100 ? '20vh' : '40vh')) : '20vh'}
              section={'คงเหลือ'}
              persent={performanceP1?.PERCENT_ACTUAL_WEIGHT === undefined ? 0 : (performanceP1?.PERCENT_ACTUAL_WEIGHT === 'NA' ? 'NA' : (100 - performanceP1?.PERCENT_ACTUAL_WEIGHT <= 0 ? 0 : 100 - performanceP1?.PERCENT_ACTUAL_WEIGHT))}
              color_persent={colors.secondary[800]}
              value={performanceP1?.REMAINING_WEIGHT === undefined ? 0 : (performanceP1?.REMAINING_WEIGHT == 'NA' ? 'NA' : (performanceP1?.REMAINING_WEIGHT <= 0 ? 0 : Math.round(performanceP1?.REMAINING_WEIGHT).toLocaleString()))}
            />
          </Grid>

          <Grid item xs={12} textAlign="left" style={{ paddingRight: 0, paddingLeft: 150 }}>
            <Box sx={{ display: 'flex', alignItems: 'left', justifyContent: 'left' }} style={{ position: "relative", top: "0vw" }} textAlign="center">
              <Typography style={{ color: getFeedrateColor(), fontSize: 70, position: "relative", paddingLeft: 0, top: "0vw" }}>
                {performanceP1?.ACTUAL_FEED_RATE === undefined ? 0 : (performanceP1?.ACTUAL_FEED_RATE == 'NA' ? 'NA' : (Math.round(performanceP1?.ACTUAL_FEED_RATE)).toLocaleString())}
              </Typography>
              <Typography style={{ color: '#ffffff', fontSize: 50, paddingTop: 18 }}>
                &nbsp;กก./ชม.&nbsp;({performanceP1?.STD_FEED_RATE === undefined ? "Std." + 0 : (performanceP1?.STD_FEED_RATE == "ไม่มีข้อมูล Std. Cap ในระบบ" ? (performanceP1?.STD_FEED_RATE).toLocaleString() : "Std." + (performanceP1?.STD_FEED_RATE).toLocaleString())})
              </Typography>
            </Box>
          </Grid>
        </ItemTarget>
      </Grid>
    </>
  )
}

export default PerformanceLine8Page1
